<template>
  <q-btn-group rounded>
    <q-btn
      v-for="option in options"
      :key="option.value"
      :color="getColor(option.value)"
      :label="option.label"
      @click="select(option.value)"
    />
  </q-btn-group>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { status } from '../post';

interface Option {
  value: number,
  label: string
}

interface Data {
  options: Option[],
}

export default defineComponent({
  emits: ['change'],
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      options: [
        {
          label: 'Open',
          value: status.ESCALATED,
        },
        {
          label: 'Resolved',
          value: status.RESOLVED,
        },
      ],
    };
  },
  methods: {
    select(value: number): void {
      this.$emit('change', value);
    },
    isSelected(value: number): boolean {
      return (this.value === value);
    },
    getColor(value: number): string|undefined {
      return this.isSelected(value) ? 'primary' : undefined;
    },
  },
});
</script>
